var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-row',{attrs:{"align":"center","justify":"center","no-gutters":""}},[_c('div',{staticStyle:{"max-width":"120px"}},[_c('stock-photos',{key:_vm.item.id,attrs:{"display-carrousel":false,"display-reference":false,"item":_vm.item}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }